const flickrApiKey = "104aab2cc8d2653989382fe91bbd32f6";

export { flickrApiKey };



// WEBPACK FOOTER //
// ./src/config.js